import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllEduLevels } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/eduLevels";
const eduLevelsSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(eduLevelsThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(eduLevelsThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(eduLevelsThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const eduLevelsThunk = createAsyncThunk(
  `${sliceName}/eduLevelsThunk`,
  async () => {
    const response = await getAllEduLevels()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.eduLevels);
    },
  },
);

export default eduLevelsSlice.reducer;
